import React, { useMemo } from 'react';
import moment from 'moment';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { getDataByKey } from '@/pages/dashboard/components/TrendChartCo/_utils/common';

const MetricCardContext = (props: any) => {
  const { children, config, isLoading, filterVal, ...restProps } = props;
  const { dataKey, metricsName, trendDataKey, apiDataKey, isRealTime = false, isNightingale = false } = config || {};
  const { [apiDataKey]: apiData } = props?.data || {};

  const data: { [key: string]: any; } = {};
  dataKey?.forEach((key: string) => {
    // 支持嵌套路径，如 "cpi.card" 或 "{{cpi.card}}"
    data[key] = getDataByKey(key, apiData?.data);
  });

  const chartData: { [key: string]: any; } = {};
  trendDataKey?.forEach((key: string) => {
    // 支持嵌套路径，如 "cpi.breakdown" 或 "{{cpi.breakdown}}"
    chartData[key] = getDataByKey(key, apiData?.data);
  });
  const time = filterVal?.singleDaily;

  const metricsDataArray = useMemo(() => {
    return Object.keys(data).map(key => data[key]);
  }, [data]);

  // const chartDataArray = useMemo(() => {
  //   return Object.keys(chartData).map(key => chartData[key]);
  // }, [chartData]);

  // 卡片根据overview metric的卡片数据格式化
  const metricsData = metricsDataArray.map((item, index) => ({
    metrics_name: metricsName?.[index] || dataKey?.[index],
    dod: {
      last_time: item?.dod_time,
      last_value: item?.dod_count,
      show_value: item?.dod,
      this_time: item?.current_time,
      this_value: item?.current_count
    },
    sdlw: {
      last_time: item?.sdlw_time,
      last_value: item?.sdlw_count,
      show_value: item?.sdlw,
      this_time: item?.current_time,
      this_value: item?.current_count
    },
    change: {
      last_time: '',
      last_value: '',
      show_value: '',
      this_time: '',
      this_value: ''
    },
    value: item?.current_count,
  }));

  // 趋势图数据格式化
  const { trendData, xAxisNightingaleData } = useMemo(() => {
    const trendData: any = {};
    const xAxisNightingaleData: any = {};
    trendDataKey?.map((item: string | number) => {
      const data = chartData[item] || {};
      const { line_dot, line_dot_last, line_dot_contrast } = data || {};
      const dataByLegend = [line_dot || [], line_dot_last || [], line_dot_contrast || []];
      const maxArr = (JSON.parse(JSON.stringify(dataByLegend)).sort((a: string, b: string) => (b.length - a.length)))[0];
      const itemXAxisData = maxArr.map((i: { time_dot: moment.MomentInput; }) => {
        const _time = i?.time_dot ? moment(i?.time_dot).format('YYYY-MM-DD HH:mm') : '';
        return `${time}${_time.slice(10)}`;
      });
      xAxisNightingaleData[item] = itemXAxisData;
      const lineDotArr = line_dot?.map((item: { count: string; }) => item?.count);
      const lineDotLastArr = line_dot_last?.map((item: { count: string; }) => item?.count);
      const lineDotContrastArr = line_dot_contrast?.map((item: { count: string; }) => item?.count);
      trendData[item] = [lineDotArr, lineDotLastArr, lineDotContrastArr];
    });
    return { trendData, xAxisNightingaleData };

  }, [chartData]);

  const firstKey = Object.keys(xAxisNightingaleData)[0]; // 获取第一个键
  const xAxisData = xAxisNightingaleData[firstKey];

  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => {
      return React.cloneElement(
        child,
        {
          ...restProps,
          metricsData,
          trendData,
          xAxisData,
          isRealTime: isRealTime,
          isNightingale: isNightingale,
          state: {}
        }
      );
    })
  );

  return (
    <Abnormal
      isLoading={false}
      isError={apiData?.errorMsg}
      style={{ background: '#fff', marginTop: '20px' }}
      component={componentItem}
    />
  );
};

export default MetricCardContext;